import { render, staticRenderFns } from "./Zahlungsarten.vue?vue&type=template&id=6486541c&scoped=true"
import script from "./Zahlungsarten.vue?vue&type=script&lang=js"
export * from "./Zahlungsarten.vue?vue&type=script&lang=js"
import style0 from "./Zahlungsarten.vue?vue&type=style&index=0&id=6486541c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486541c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6486541c')) {
      api.createRecord('6486541c', component.options)
    } else {
      api.reload('6486541c', component.options)
    }
    module.hot.accept("./Zahlungsarten.vue?vue&type=template&id=6486541c&scoped=true", function () {
      api.rerender('6486541c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Zahlungsarten.vue"
export default component.exports